//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralTable from '@/components/GeneralTable';
import { log } from 'util';
import checkPermission from '@/utils/permission'; // 权限判断函数

export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      moduleName: 'city_module',
      tableName: 't_city',
      url: {
        getUrl: '/city',
        method: 'post',
        query: {}
      },
      canSearch: checkPermission('master.city.list'),
      //true,
      canAdd: checkPermission('master.city.add'),
      //true,
      canEdit: checkPermission('master.city.edit'),
      //true,
      canDelete: checkPermission('master.city.delete'),
      //true,
      canBatchEdit: false,
      // checkPermission('master.city.batch'), //true,
      canDownload: checkPermission('master.city.download'),
      //true
      canImport: checkPermission('master.city.import_data')
    };
  },
  created: function created() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    if (this.$refs.GeneralTable) {
      sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()));
    }
    next();
  },
  methods: {}
};